import React from "react";
import { Link } from "react-router-dom";
import "./breadcrumb.css";

const Breadcrumb = ({ items = [], className = "" }) => {
    const visibleItems = items.filter((item) => item && item.label);
    if (visibleItems.length === 0) return null;

    return (
        <nav aria-label="Breadcrumb" className={`app-breadcrumb ${className}`.trim()}>
            <div className="app-breadcrumb__trail">
                {visibleItems.map((item, index) => (
                    <React.Fragment key={`${index}-${item.label}`}>
                        {index > 0 && (
                            <span aria-hidden="true" className="app-breadcrumb__separator"> / </span>
                        )}
                        {item.to ? (
                            <Link className="app-breadcrumb__link" to={item.to} title={item.label}>
                                {item.label}
                            </Link>
                        ) : (
                            <span className="app-breadcrumb__text">{item.label}</span>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </nav>
    );
};

export default Breadcrumb;
